import PropTypes from "prop-types";
import moment from "moment";
import "./Layout.css";
import React from 'react';
import { version, build, ts } from "../version.json";
import WebNetButton from "./WebNetButton";
import UiAlert from "./UiAlert";
import LanguageSelect from "./LanguageSelect";
import  WebNetOptios  from "./WebNetOptions";

import ItemSelect from "./WebNetSelect";
import i18n from '../i18n';

import { Button, } from "@blueprintjs/core";

import logo from "../assets/Themidas_logo.png";

//import saveReportPDF from "./PrintReport";
//import WebNetClock from "./WebNetClock";

require('dotenv').config();

import { useTranslation } from 'react-i18next';

const iconTemp = (temp) => {
    return temp ? "\u00B0C" : "\u00B0F"
}

const Layout = (props) => {

    const { t } = useTranslation();

    const {
        Component,
        languageSelected,
        handleLanguageSelected,
        alertSeverity,
        alertMessage,
        handleMessage,
        handleIsCelcius,
        isCelcius,
        selectedImagesThumbnailData
      


    } = props;

            
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        handleLanguageSelected(lng);

    };

    let lng = localStorage.getItem("i18nextLng");

    const handleIsCelciusTemp = () => {
        handleIsCelcius(isCelcius);
    }

    const handleReportPDF = () => {
        saveReportPDF(selectedImagesThumbnailData);
    }

    return <React.Fragment>

        <div className="navigation">
            <div className="logo"> 
                <img alt="Thermal WebNet" className="logo" src={logo} /> 
            </div>

            <WebNetOptios {...props} />

            <ItemSelect items={["en", "fi", "es"]} selectedItem={lng || "en"} onSelect={(lang) => changeLanguage(lang)} widthX={50} heightY={30} label="" />
            <Button className="actionButtonText" text={iconTemp(isCelcius)} onClick={handleIsCelciusTemp} 
                title={isCelcius ? "Clik to change to Farh. \r\n for all images" 
                    : "Clik to change to Celcius \r\n for all images"} >
            </Button>
            {/*<Button className="actionButtonText" icon={"print"} onClick={handleReportPDF}*/}
            {/*    title={isCelcius ? "Clik to change to Farh. \r\n for all images"*/}
            {/*        : "Clik to change to Celcius \r\n for all images"} >*/}
            {/*</Button>*/}
            
            <div className="actions"> 
                {/*<LanguageSelect languageSelected={languageSelected} handleLanguageSelected={handleLanguageSelected} />*/}
                <WebNetButton neverActive={false} path="/logout" text={t("Logout")} /> 
                

            </div>
        </div>
        
        {alertMessage !=="" ? <UiAlert alertSeverity={alertSeverity} alertMessage={t(alertMessage)} handleMessage={handleMessage} /> : null }

        <React.StrictMode>
            <div id="main" className="main">
                <div id="content" className="content">
                    <Component />
                </div>
            </div>
        </React.StrictMode>

        <footer>
            <div>
                Thermidas Oy - Polttimonkatu 4, 33210 Tampere Finland
            </div>
            <div className="version">
                {t("Version")} {version}
                {process.env.NODE_ENV === "development" ? ` Build-${build} / Build time ${moment(ts).format('yy-MM-DD / hh:mm')}` : ""}
                
            </div>
        </footer>
        
        </React.Fragment>;
};
export default Layout;

Layout.propTypes = {
    Component: PropTypes.func.isRequired,
    alertMessage: PropTypes.string,
    handleMessage: PropTypes.func.isRequired,

    

};

/*
             <div className="buttons">
                <WebNetButton path="/viewer" text={t('Viewer')} ></WebNetButton>
            </div>

            <div className="actions">
                <WebNetButton neverActive={false} path="/logout" text={t("Logout")} />
                <WebNetButton neverActive={false} path="/usersettings" icon="user" />
                <WebNetButton neverActive={false} path="/notifications" icon="notifications" />
                <WebNetButton neverActive={false} path="/config" icon="cog" />
                <LanguageSelect languageSelected={languageSelected} />
            </div>

        Current time <WebNetClock />
 */